import React from 'react';

/**
 * Compact skeleton for overview leaderboard preview while loading.
 */
export function LeaderboardOverviewPreviewSkeleton() {
  return (
    <div className="animate-pulse space-y-3" aria-hidden="true">
      <div className="flex gap-1.5">
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-7 w-16 rounded-full bg-border-light" />
        ))}
      </div>
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className="flex items-center gap-3 rounded-full px-3 py-2.5 bg-surface-subtle border border-border-light"
        >
          <div className="h-8 w-8 rounded-full bg-border-light shrink-0" />
          <div className="h-3 flex-1 max-w-[8rem] bg-border-light rounded" />
          <div className="h-3 w-10 bg-border-light rounded" />
        </div>
      ))}
    </div>
  );
}

export default LeaderboardOverviewPreviewSkeleton;
